
import { defineComponent, VueElement, ref } from 'vue';
import MdEditor from 'md-editor-v3';
import 'md-editor-v3/lib/style.css';
import type { ExposeParam } from 'md-editor-v3';

import * as _ from 'lodash';
import { _ServerApi } from '@/serverAPI';
import { _Util,UPLOAD_SIZE_STRING } from '@/MyUtil';
import { add } from 'lodash';


interface IImgScroolX {
  is_down: boolean,
  startX: number,
  scrollLeft: number,
}

interface IImgListItem{
  "file_name" :string,
  "img_idx" : number,
  "tag" : string[],
}


export default defineComponent({
  name: 'JoinAgree',
  data() {
    return {
      "util" : _Util.getInstance(),
      "img_scrool_x": {
        "is_down": false,
        "startX": 0,
        "scrollLeft": 0,
      } as IImgScroolX,
      "img_search_val" : "",
      "text": "",
      "arr_img_list" : [] as IImgListItem[],
      "is_img_select_open" : false,
      "selected_img_pop_up_menu" : "search",
      "add_img_page" : {
        "add_img" : "",
        "add_input_text" : "",
        "add_tag_list" : [] as string[],
      },
      "selected_img_list" : [] as IImgListItem[],

      "wd"  : {
        "board_idx" : "",
        "title" : "",
        "cont" : "",
        "open_type" : "0",
        "main_img" : "",
        "url_key" : "",
      }


    }
  },

  computed:{
    add_img_url(){
      const util = _Util.getInstance();

      const file_name = this.add_img_page.add_img as string;
      const size_type = UPLOAD_SIZE_STRING.S_540X283;

      return util.getImgURL(file_name,size_type);
    }
  },

  components: {
    "md-editor-v3": MdEditor
  },
  methods: {

    BindScroolX(refsName: string, obj: IImgScroolX) {
      const img_list_wrap: VueElement = this.$refs[refsName] as VueElement;
      img_list_wrap.addEventListener('mousedown', e => {
        const event: MouseEvent = e as MouseEvent;
        obj.is_down = true;
        img_list_wrap.classList.add('active');
        obj.startX = event.pageX - img_list_wrap.offsetLeft;
        obj.scrollLeft = img_list_wrap.scrollLeft;
      });
      img_list_wrap.addEventListener('mouseleave', () => {
        obj.is_down = false;
        img_list_wrap.classList.remove('active');
      });

      img_list_wrap.addEventListener('mouseup', () => {
        obj.is_down = false;
        img_list_wrap.classList.remove('active');
      });

      img_list_wrap.addEventListener('mousemove', e => {
        const event: MouseEvent = e as MouseEvent;
        if (!obj.is_down) return;
        event.preventDefault();
        const x = event.pageX - img_list_wrap.offsetLeft;
        const walk = x - obj.startX;
        img_list_wrap.scrollLeft = obj.scrollLeft - walk;
      });

    },

    getImg(file_name:string){
      return this.util.getImgURL(file_name,UPLOAD_SIZE_STRING.S_312X168);
    },

    click_selectImg(img_item:IImgListItem){
      const is_dbClick = this.util.checkDBClick("click_selectImg:1100");
      if(is_dbClick){
        this.dbclick_selectImg(img_item);
      }

    },

    dbclick_selectImg(img_item:IImgListItem){
      //this.selected_img_list.push(img_item);
      const find = _.find(this.selected_img_list,(d)=>{
        return d.file_name == img_item.file_name;
      });
      if(!_.isUndefined(find)){
        this.add_noti("이미 등록 된 이미지 입니다.");
        return;
      }

      this.selected_img_list.unshift(img_item);
      this.is_img_select_open = false;
    },

    async delete_imgList(img_item:IImgListItem){
      if(!confirm("해당 이미지를 삭제 하시겠습니까?")){
        return;
      }

      const img_idx = img_item.img_idx;
      const _api = _ServerApi.getInstance();
      const result = await _api.postJson("/api/delImg",{
        "img_idx" : img_idx,
      });

      if(result.isError){
        this.util.add_noti({
          vue_ele : this.$root,
          "msg" : result.msg,
        });
        return;
      }
      const list = this.arr_img_list;
      this.arr_img_list = _.filter(list,(d:IImgListItem)=>{
        return d !== img_item;
      });

    },

    async open_img_select_pop(is_view: boolean) {
      this.is_img_select_open = is_view;
      await this.bindGetListImgSearch();
    },

    async set_selected_img_pop_up_menu(menu_name: string) {
      this.selected_img_pop_up_menu = menu_name;
      await this.bindGetListImgSearch();
    },

    async bindGetListImgSearch(){
      const menu_name = this.selected_img_pop_up_menu;
      if(this.is_img_select_open == false){
        return;
      }
      if(menu_name != "search"){
        return;
      }
      this.img_search_val = "";
      this.arr_img_list = [];

      var list = await  this.getDataImgList(false);
      //console.log(list);

      _.each(list,(d)=>{
        this.arr_img_list.push(d);
      });
      console.log(this.arr_img_list.length);
      /**
       * 이미지 리스트 정리.
        /api/getImgList
        next_idx 다음들 인덱스 없으면 ""
        search_val : 검색어 없으면 ""
       */

      console.log("bindGetListImgSearch");
    },
    
    async bindGetNextImgSearch(){
      var list = await this.getDataImgList(true);
      _.each(list,(d)=>{
        this.arr_img_list.push(d);
      });
    },

    async bindGetListImgSearchVal()
    {
      var list = await this.getDataImgList(false);
      console.log("result",list);
      await this.util.waitTime(1);

      this.arr_img_list = list as IImgListItem[];
    },


    async getDataImgList(is_next:boolean){

      const search_val = this.img_search_val;
      //console.log("search_val",search_val);
      const img_list = this.arr_img_list;
      let next_idx = "";
      if(img_list.length != 0){
        const last = _.last(img_list);
        next_idx = last?.img_idx + "";
      }
      if(is_next == false){
        next_idx = "";
      }
      const _api = _ServerApi.getInstance();
      
      var result = await _api.postJson("/api/getImgList",{
        "next_idx" : next_idx,
        "search_val" : search_val
      });

      if (result.isError) {
        this.util.add_noti({
          vue_ele: this.$root,
          msg: result.msg,
        })
        return [] as Array<IImgListItem>;
      }
      return result.list as Array<IImgListItem>;
    },

    clickCodeCopy(img_item: IImgListItem) {

      const url = this.util.getImgURL(img_item.file_name, UPLOAD_SIZE_STRING.S_origin);
      //![](https://www.naver.com)
      const copy_editor = `![](${url})`;

      if (location.protocol === 'https:') {
        navigator.clipboard.writeText(copy_editor).then(() => {
          this.util.add_noti({
            vue_ele: this.$root,
            msg: "클립보드로 이미지가 복사 되었습니다."
          });
          console.log("clickCodeCopy");

        }).catch(e => {
          console.log(e);
        })
        //location.replace(`https:${location.href.substring(location.protocol.length)}`);
      }
      else {
        copyToClipboard(copy_editor);
        this.util.add_noti({
            vue_ele: this.$root,
            msg: "클립보드로 이미지가 복사 되었습니다."
        });
        //alert('복사 되었습니다.');
      }
    },

    clickDelImg(img_item:IImgListItem) {
      confirm("해당 이미지를 삭제 하시겠습니까?")
      const list = this.selected_img_list;
      this.selected_img_list = _.filter(list,(d)=>{
        return d !== img_item
      })
    },

    async clickBoardSave() {

                  

      
      if(this.wd.title.length == 0){
        this.add_noti("제목을 입력하세요.");
        return;
      }
      if(this.wd.cont.length == 0){
        this.add_noti("내용을 입력 하세요.");
        return;
      }
      if(this.selected_img_list.length == 0){
        this.add_noti("이미지를 입력하세요.");
        return;
      }

      const find = _.find(this.selected_img_list,(d)=>{
        return d.file_name == this.wd.main_img;
      });
      if(_.isUndefined(find)){
        this.add_noti("메인 이미지를 설정하세요. (이미지 더블 클릭)");
        return;
      }
      if(!this.util.isOnlyNumAlphabet(this.wd.url_key)){
        this.add_noti("페이지키는 숫자와 알파벳만 들어갑니다.");
        return;
      }
      if(!confirm("해당 내용으로 입력 하시겠습니까?")){
        return;
      }
      const img_file_name_list = _.map(this.selected_img_list,"file_name");
      console.log("img_file_name_list",img_file_name_list);

      const form = {
        "board_idx" : this.wd.board_idx,
        "title" : this.wd.title,
        "cont" : this.wd.cont,
        "img_file_name_list" : JSON.stringify(img_file_name_list),
        "main_img" : this.wd.main_img,
        "open_type" : this.wd.open_type,
        "url_key" : this.wd.url_key,

      }
      const api = _ServerApi.getInstance();
      this.util.setLoading({
        vue_ele: this.$root,
        isLoading:true,
      });
      const result = await api.postJson("/api/saveBoard",form);
      await this.util.waitTime(500);
      this.util.setLoading({
        vue_ele: this.$root,
        isLoading:false,
      });
      if(result.isError){
        this.add_noti(result.msg);
        return;
      }

      if(this.wd.board_idx  == ""){
        this.$router.replace("/");
      }
      else
      {
        this.$router.replace(`/v/${this.wd.url_key}`);
      }

      
    },

    async changeUpImg(event: any) {
      const files: FileList = event.target.files as FileList;
      if (files.length == 0) {
        alert("잘못된 인자입니다.");
        return;
      }
      const file = files[0];
      const _api = _ServerApi.getInstance();

      this.util.setLoading({vue_ele:this.$root,isLoading:true});
      const result = await _api.postJsonSendFile("/api/uploadImg", file);
      await this.util.waitTime(1000);
      this.util.setLoading({vue_ele:this.$root,isLoading:false});


      if(result.isError){
        alert(result.msg);
        return;
      }

      const list = result.list;
      console.log(list);
      const img_flie = list[0];
      const file_name = img_flie.filename;
      this.add_img_page.add_img = file_name;


    },

    add_noti(msg:string){
      const root = this.$root;
      this.util.add_noti({
          vue_ele : root,
          msg : msg
        });
    },

    add_img_search_text(){
      const text = this.add_img_page.add_input_text;
      const tag_list = this.add_img_page.add_tag_list;  
      const root = this.$root;

      function add_noti(msg:string){
        const util = _Util.getInstance();
        util.add_noti({
          vue_ele : root,
          msg : msg
        });
        return;
      }
      if(text == ""){
        add_noti("검색어를 입력하세요");
        return;
      }
      if(text.length > 10){
        add_noti("태그는 10자를 넘을 수 없습니다.");
        return;
      }
      const is_has = _.includes(tag_list,text);
      if(is_has){
        add_noti("태그가 중복되었습니다.");
        return;
      }

      tag_list.push(text);
      console.log(text);
      this.add_img_page.add_input_text = "";


    },

    del_img_tag(tag:string){
      let tag_list = this.add_img_page.add_tag_list;  

      tag_list = _.filter(tag_list,(d)=>{
        return d != tag;
      });
      this.add_img_page.add_tag_list = tag_list;

      console.log(tag_list);

    },

    async save_add_img(){
      const root = this.$root;
      function add_noti(msg:string){
        const util = _Util.getInstance();
        util.add_noti({
          vue_ele : root,
          msg : msg
        });
        return;
      }

      if(this.add_img_page.add_img == ""){
        add_noti("이미지를 넣어주세요");
        return;
      }
      const tag_count = this.add_img_page.add_tag_list.length;
      if(tag_count == 0){
        add_noti("태그는 최소 하나는 입력해 주세요.");
        return;
      }

      if(!confirm("해당 이미지를 입력 하시겠습니까?")){
        return;
      }


      const util = this.util;
      const img_file_name = this.add_img_page.add_img;
      const tag_list = JSON.stringify(this.add_img_page.add_tag_list);
      var _api = _ServerApi.getInstance();
      util.setLoading({
        vue_ele:this.$root,
        isLoading:true,
      })
      const result = await _api.postJson("/api/addImg",{
        "tag_list" : tag_list,
        "img_file_name" :img_file_name,
      });
      await util.waitTime(500);
      util.setLoading({
        vue_ele:this.$root,
        isLoading:false,
      })

      if(result.isError){
        alert(result.msg)
        return;
      }

      this.add_img_page.add_img = "";
      this.add_img_page.add_tag_list = [];
      
    },

    click_selected_img(d:IImgListItem){
      const result = this.util.checkDBClick("click_selected_img:VV1");
      if(result){
        this.dbclick_selected_img(d);
      }
    },

    dbclick_selected_img(d:IImgListItem){
      this.wd.main_img = d.file_name;
    },
    showImgPop(d:IImgListItem){
      console.log("showImgPop",d);
      const util = this.util;
      const img_url = util.getImgURL(d.file_name,UPLOAD_SIZE_STRING.S_origin);
      this.util.openImgPop({
        img_url: img_url,
        is_open:true,
        vue_ele:this.$root,
      })
    },

    clickBtnRandomUrl(){
      const str = "0123456789";
      const range = _.range(0,20);
      const arr_value = _.map(range,(d)=>{
        return _.sample(str);
      });
      this.wd.url_key = arr_value.join("");
      //return arr_value.join("");
    },


  },
  
  async mounted() {
    this.BindScroolX("img_list_wrap", this.img_scrool_x);
    const query = this.$route.query;
    const _api = _ServerApi.getInstance();


    let url_key = "";
    if(query.url_key != undefined){
      url_key = query.url_key + "";
    }
    console.log("url_key",url_key)
    
    if(url_key != ""){
      this.util.setFullSize({
        is_full: true,
        vue_ele: this.$root,
      });

      const result = await _api.postJson("/api/getBoardView",{
        url_key : url_key,
      });
      if(result.isError){
        alert(result.msg);
        this.$router.replace("/");
        return;
      }
      if(!result.is_my_board){
        alert("자신의 글만 수정 가능합니다.");
        this.$router.replace("/");
        return;
      }
      console.log(result);
      const doc = result.doc;
      const board_list = result.board_img_list as IImgListItem[];
      console.log(doc);
      this.wd.board_idx = doc.board_idx;
      this.wd.cont = doc.cont;
      this.wd.main_img = doc.main_img;
      this.wd.open_type = doc.open_type;
      this.wd.title = doc.title;
      this.wd.url_key = doc.url_key;
      this.selected_img_list = board_list;

    }

    const editorRef = this.$refs.editorRef as ExposeParam;
    editorRef.on('fullscreen', (status) => console.log(status));
    editorRef.on('catalog', console.log);
    editorRef.on('pageFullscreen', (status) => console.log(status));
    //console.log(editorRef,editorRef.on);

    const collection = document.getElementsByClassName("md-editor-content");
    console.log(collection);

    _.each(collection, (ele) => {
      const htmlEle = ele as HTMLElement;
      htmlEle.style.setProperty("height",'calc(100% - 64px)');
      console.log("사이즈 적용됨");
      
    });

  },


});

function copyToClipboard(val:string) {
    const t = document.createElement("textarea");
    document.body.appendChild(t);
    t.value = val;
    t.select();
    document.execCommand('copy');
    document.body.removeChild(t);
}

